export default "__VITE_ASSET__CVRmdumh__"